import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {DtActionsService} from '../../widgets/data-table/services/dt-actions.service';

@Component({
  selector: 'app-main-global',
  imports: [],
  templateUrl: './main-global.html',
  styleUrl: './main-global.scss'
})
export class MainGlobal {

  private router = inject(Router);
  private actionService = inject(DtActionsService);

  get showActions() {
    return this.actionService.actions().length > 0;
  }

  get marginBottom() {
    return this.router.url === 'notifiche'
  }
}
